import React from 'react';
import { Link } from 'react-router-dom';
import ButtonTwo from '../Button/ButtonTwo';
import Image from '../../assets/img/blog/blog-3-1.jpg';

const SingleBlogTwo = ({
  id,
  itemClass,
  blogImage,
  publishedDate,
  titleClass,
  title,
  description,
  hasArrow,
  btnClass,
  btnText,
  descriptionClass = 'pt-2', // ✅ default padding between title & description
}) => {
  const detailsUrl = `/blog-details/${id}`;

  return (
    <div
      className={itemClass ? itemClass : 'it-blog-2-item'}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        backgroundColor: '#ffffff',
        padding: '24px',
        margin: '12px',
        borderRadius: '20px',
        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s ease-in-out',
        border: '1px solid #f0f0f0',
        overflow: 'hidden',
        cursor: 'pointer',
        position: 'relative',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-6px)';
        e.currentTarget.style.boxShadow = '0 18px 40px rgba(0, 0, 0, 0.12)';
        e.currentTarget.style.borderColor = '#e0e0e0';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 12px 32px rgba(0, 0, 0, 0.08)';
        e.currentTarget.style.borderColor = '#f0f0f0';
      }}
    >
      {/* Top Gradient Accent */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '4px',
          width: '100%',
          background: 'linear-gradient(90deg, #ee344e, rgb(11, 42, 91))',
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
        }}
      />

      {/* Blog Image */}
      <div
        style={{
          marginBottom: '20px',
          borderRadius: '12px',
          overflow: 'hidden',
        }}
      >
        <Link to={detailsUrl}>
          <img
            src={blogImage ? blogImage : Image}
            alt=""
            style={{ width: '100%', height: '200px', objectFit: 'cover' }}
          />
        </Link>
      </div>

      {/* Meta Date */}
      <div className="it-blog-2-meta pb-10">
        <span style={{ fontSize: '14px', color: '#999' }}>
          {publishedDate || '15 JUNE, 24'}
        </span>
      </div>

      {/* Title */}
      <h4
        className="it-blog-title mb-0 pb-10"
        style={{
          fontSize: '20px',
          height: '52px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          marginBottom: '12px',
        }}
      >
        <Link
          className={titleClass ? titleClass : 'hover-anim tertiary'}
          to={detailsUrl}
          style={{ textDecoration: 'none', color: '#333' }}
        >
          {title || 'Healthcare Tips Navigating Business Patient Care'}
        </Link>
      </h4>

      {/* Description with padding */}
      <p
        className={`mb-25 ${descriptionClass}`}
        style={{
          fontSize: '15px',
          color: '#555',
          lineHeight: '1.6',
          height: '90px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 5,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {description || 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'}
      </p>

      {/* Read More Button */}
      <div style={{ marginTop: 'auto' }}>
        {hasArrow ? (
          <ButtonTwo
            btnURL={detailsUrl}
            btnClass="it-btn-theme blog-btn red-bg mr-35"
            btnText={btnText || 'Read More'}
          />
        ) : (
          <Link
            to={detailsUrl}
            className={btnClass || 'it-btn-theme blog-btn tertiary-bg'}
            style={{
              display: 'inline-block',
              backgroundColor: '#ff5858',
              color: '#fff',
              padding: '10px 20px',
              borderRadius: '8px',
              fontWeight: 500,
              fontSize: '14px',
              textDecoration: 'none',
              transition: 'background-color 0.3s ease',
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = '#e74c3c')
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = '#ff5858')
            }
          >
            {btnText || 'Read More →'}
          </Link>
        )}
      </div>
    </div>
  );
};

export default SingleBlogTwo;
